module.exports = __webpack_public_path__ + "img/osa_device-wireless-router.568a355f.svg";